export default "__VITE_ASSET__de329c80__"